<script setup>
import ToastPopups from '@/components/core/dialogs/ToastPopups.vue';
import SharedMessagePopup from '@/components/SharedMessagePopup.vue';
import GlobalConfirmDialog from '@/components/core/dialogs/GlobalConfirmDialog.vue';
</script>

<template>
  <div>
    <ToastPopups />
    <SharedMessagePopup />
    <GlobalConfirmDialog />
  </div>
</template>
